import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { filter, map, Observable, of, take } from 'rxjs';
import { Store } from '@ngrx/store';
import * as userActions from '../../../shared/src/lib/store/actions/user.actions';
import { AppStateManage } from './manage.states';

@Injectable({
    providedIn: 'root'
})
export class ManageInitialDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(
        private store: Store<AppStateManage>
    ) {
    }

    waitUser(): Observable<any> {
        return this.store.select("user").pipe(
            map(store => store),
            filter(store => store.loading === false),
            take(1)
        )
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        // return of(true);
        this.store.dispatch(userActions.GetUser());
        return this.waitUser();
    }
}
